"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var selectPaymentAmountStyles_1 = require("./selectPaymentAmountStyles");
var clsx_1 = require("clsx");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var useTotalPrice_1 = require("../../../../common/hooks/prices/useTotalPrice");
var useCurrencyPreference_1 = require("../../../context/useCurrencyPreference");
var Price_1 = require("../../../../common/components/prices/price/Price");
var PriceDisplayType_1 = require("../../../../../../../common/enum/PriceDisplayType");
var useMoney_1 = require("../../../../common/hooks/prices/useMoney");
var globalTypes_1 = require("../../../../../__generated__/globalTypes");
var PriceSelectionValues;
(function (PriceSelectionValues) {
    PriceSelectionValues["reservation"] = "RESERVATION";
    PriceSelectionValues["full"] = "FULL";
})(PriceSelectionValues || (PriceSelectionValues = {}));
var SelectPaymentAmount = function () {
    var _a, _b, _c, _d, _e, _f;
    var styles = selectPaymentAmountStyles_1.default();
    var _g = useCheckoutContext_1.default(), deal = _g.deal, setPaymentType = _g.setPaymentType;
    var _h = useCurrencyPreference_1.default(), isSecondaryCurrencyDisplay = _h.isSecondaryCurrencyDisplay, displayedCurrency = _h.displayedCurrency;
    var totalFinalPrices = useTotalPrice_1.default(deal.car.prices.totalPrice).totalFinalPrices;
    var primaryTotalPrice = totalFinalPrices[0], secondaryTotalPrice = totalFinalPrices[1];
    var reserveFee = (_b = (_a = deal.attributes) === null || _a === void 0 ? void 0 : _a.paymentFee) === null || _b === void 0 ? void 0 : _b.reserveFee;
    var _j = useMoney_1.default(reserveFee), primaryPrice = _j.primaryPrice, secondaryPrice = _j.secondaryPrice;
    var _k = react_1.useState(PriceSelectionValues.reservation), selectedValue = _k[0], setSelectedValue = _k[1];
    var handleRadioChange = function (event) {
        var value = event.target.value;
        setSelectedValue(value);
        if (value === PriceSelectionValues.reservation) {
            setPaymentType(globalTypes_1.PaymentType.reservation_fee);
        }
        else {
            setPaymentType(globalTypes_1.PaymentType.full_payment);
        }
    };
    var radioData = [
        {
            value: PriceSelectionValues.reservation,
            translationId: 'trans__checkout__next_step__payment_page__select_amount__reservation_fee_label',
            price: isSecondaryCurrencyDisplay ? ((_c = secondaryPrice) === null || _c === void 0 ? void 0 : _c.amount) || 0 : ((_d = primaryPrice) === null || _d === void 0 ? void 0 : _d.amount) || 0,
            dataTest: 'select_payment:reservation_fee',
        },
        {
            value: PriceSelectionValues.full,
            translationId: 'trans__checkout__next_step__payment_page__select_amount__pay_full_order_fee_label',
            price: isSecondaryCurrencyDisplay ? ((_e = secondaryTotalPrice.money) === null || _e === void 0 ? void 0 : _e.amount) || 0 : ((_f = primaryTotalPrice.money) === null || _f === void 0 ? void 0 : _f.amount) || 0,
            dataTest: 'select_payment:full_payment',
        },
    ];
    return (<core_1.Box className={styles.container} data-test="checkout:payment_disclaimer">
      <core_1.FormControl fullWidth>
        <core_1.RadioGroup className={styles.radioGroupContainer} onChange={handleRadioChange} value={selectedValue}>
          {radioData.map(function (item) {
        var _a;
        return (<core_1.FormControlLabel key={item.value} className={clsx_1.default(styles.controlLabel, (_a = {},
            _a[styles.reserveFeeControlLabel] = item.value === PriceSelectionValues.reservation,
            _a[styles.fullFeeControlLabel] = item.value === PriceSelectionValues.full,
            _a))} data-test={item.dataTest} label={<core_1.Typography variant="subtitle1" className={styles[item.value === PriceSelectionValues.reservation ? 'reserveFeeControlLabel' : 'fullFeeControlLabel']}>
                  <Translation_1.default id={item.translationId} values={{
            amount: (<span className={styles.amount}>
                          (
                          <Price_1.default price={item.price} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={displayedCurrency} className={styles.amount} variant="h5"/>
                          )
                        </span>),
        }}/>
                </core_1.Typography>} value={item.value} labelPlacement="start" control={<core_1.Radio className={styles.controlRadioButton} classes={{
            root: styles.radio,
            checked: styles.checked,
        }}/>}/>);
    })}
        </core_1.RadioGroup>
      </core_1.FormControl>
    </core_1.Box>);
};
exports.default = SelectPaymentAmount;
